'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAction = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _util = require('@ux/util');

var _trafficManager = require('./traffic-manager');

var _trafficManager2 = _interopRequireDefault(_trafficManager);

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var campaignId = 'RequestACall';
var TZ = '(UTC-07:00) Arizona';

var createModeXmlNode = function createModeXmlNode(phoneNo) {
  return '\n    <Data>\n      <Phone1>\n      <Cvalue>' + phoneNo + '</Cvalue>\n      <TZ>' + TZ + '</TZ>\n      </Phone1>\n    </Data>\n  ';
};

var getBusinessFieldXml = function getBusinessFieldXml(payload) {
  var waitTime = payload.waitTime,
      timeStamp = payload.timeStamp,
      callbackTime = payload.callbackTime,
      callbackEndTime = payload.callbackEndTime,
      routeId = payload.routeId,
      callTypeID = payload.callTypeID,
      agentDisplay = payload.agentDisplay,
      firstName = payload.firstName,
      lastName = payload.lastName,
      shopperId = payload.shopperId,
      visitorId = payload.visitorId,
      ucid = payload.ucid;

  return '\n    <Data>\n      <AgentDisplay>' + agentDisplay + '</AgentDisplay>\n      <CallTypeID>' + callTypeID + '</CallTypeID>\n      <RouteId>' + routeId + '</RouteId>\n      <FirstName>' + firstName + '</FirstName>\n      <LastName>' + lastName + '</LastName>\n      <UCID>' + ucid + '</UCID>\n      <ShopperID>' + shopperId + '</ShopperID>\n      <VisitorID>' + visitorId + '</VisitorID>\n      <WaitTime>' + waitTime + '</WaitTime>\n      <TimeStamp>' + timeStamp + '</TimeStamp>\n      <CallbackTime>' + callbackTime + '</CallbackTime>\n      <CallbackEndTime>' + callbackEndTime + '</CallbackEndTime>\n    </Data>\n  ';
};

var getUserInfo = function getUserInfo() {
  var infoIdp = _util.cookie.get('info_idp');

  var _ref = infoIdp && JSON.parse(infoIdp) || {},
      info_shopperId = _ref.info_shopperId,
      firstname = _ref.firstname,
      lastname = _ref.lastname;

  var visitor = _util.cookie.get('visitor');
  return {
    shopperId: info_shopperId,
    visitorId: visitor && visitor.length > 4 ? visitor.split('=')[1] : '',
    firstName: firstname,
    lastName: lastname
  };
};

var getTimeStamp = function getTimeStamp(date, offsetInSec) {
  var copiedDate = new Date(date.getTime());
  if (offsetInSec) {
    copiedDate.setSeconds(date.getSeconds() + offsetInSec);
  }
  return copiedDate.toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'America/Phoenix'
  }).replace(',', '');
};

var getBusinessField = function getBusinessField(data) {
  var waitTimeInSec = data.waitTimeInSec,
      routeId = data.routeId,
      messageText = data.messageText,
      agentDisplay = data.agentDisplay,
      callTypeID = data.callTypeID;

  var date = new Date();
  var ucid = (0, _v2.default)();
  return _extends({
    agentDisplay: agentDisplay,
    callTypeID: callTypeID,
    routeId: routeId,
    ucid: ucid
  }, getUserInfo(), {
    phoneNo: messageText.replace(/-/g, ''),
    waitTime: waitTimeInSec,
    timeStamp: getTimeStamp(date),
    callbackTime: getTimeStamp(date, waitTimeInSec), // waitTime plus current time
    callbackEndTime: getTimeStamp(date, waitTimeInSec + 60 * 60) // 1 hr after callbackTime
  });
};

var createRacBody = function createRacBody(businessFields) {
  var callbackTime = businessFields.callbackTime,
      callbackEndTime = businessFields.callbackEndTime;


  return {
    CreateContact: [{
      CampaignID: campaignId,
      Calltype: 0,
      callStartDateTime: callbackTime,
      callEndDateTime: callbackEndTime,
      BussinessFields: getBusinessFieldXml(businessFields),
      priority: 0,
      Modes: createModeXmlNode(businessFields.phoneNo),
      AgentID: '',
      SMSData: '',
      MailSubject: '',
      MailMsg: '',
      MailAttachment: '',
      ZipCode: '',
      ContactDetail: '',
      ListID: 0,
      LeadScore: 0
    }]
  };
};

var requestACall = function requestACall() {
  return function (data) {
    var _data$actionSuccess = data.actionSuccess,
        actionSuccess = _data$actionSuccess === undefined ? 'success-event' : _data$actionSuccess,
        _data$actionFailed = data.actionFailed,
        actionFailed = _data$actionFailed === undefined ? 'failed-event' : _data$actionFailed,
        triggerEvent = data.triggerEvent,
        chatbotsApiBaseUrl = data.chatbotsApiBaseUrl,
        phoneWaitTime = data.phoneWaitTime;


    var waitTimeInMin = phoneWaitTime && !isNaN(phoneWaitTime) && Number(phoneWaitTime);
    if (waitTimeInMin === 'undefined' || waitTimeInMin && waitTimeInMin < 0) {
      return triggerEvent(actionFailed);
    }
    data.waitTimeInSec = waitTimeInMin * 60;
    var businessFields = getBusinessField(data);
    var status = '';
    try {
      var chatbotApiUrl = chatbotsApiBaseUrl + '/addContact';
      var options = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      var body = createRacBody(businessFields);
      _util.request.post(chatbotApiUrl, body, options, function (err, response) {
        if (response && response.status === 200 && response.statusMessage === 'SUCCESS') {
          status = 'success';
          triggerEvent(actionSuccess);
        } else {
          status = 'failed';
          triggerEvent(actionFailed);
        }
        if (err) {
          status = 'error';
          _trafficManager2.default.sendRequestACallCreateEvent(_extends({}, businessFields, { status: status }));
          throw new Error(err);
        }
        status = status ? status : 'error';
        _trafficManager2.default.sendRequestACallCreateEvent(_extends({}, businessFields, { status: status }));
      });
    } catch (err) {
      throw new Error(err);
    }
  };
};

var getAction = exports.getAction = function getAction(type) {
  if (type === 'rac') {
    return requestACall();
  }
};